module.exports = __webpack_public_path__ + "static/media/cameramanager-logo.ec1f76c0.png";